export default {
  shoppingCartView: {
    title: "Panier d'achat",
    agencyProductsSubtitle: "Produits de l'agence",
    boutiqueProductsSubtitle: 'Produits du boutique',
    reservedProductsSubtitle: 'Réservés',
  },
  shoppingCartEmptyView: {
    infoPar1Span1: 'Ton panier est vide. Si tu as soif, rempli-le en explorant les produits du ',
    infoPar1Span2: 'boutique de Montréal,',
    infoPar1Span3: ' ou ceux de ',
    infoPar1Span4: "l'agence",
    infoPar1Span5: '.',
    infoPar1Span7: ' boutique de Québec',
    infoPar2Span1: 'Psss, tu peux aussi trouver de la ',
    infoPar2Span2: 'nourriture',
    infoPar2Span3: ' pour emporter et une multitude de ',
    infoPar2Span4: 'produits connexes',
    infoPar2Span5: '.',
    infoPar1Span8: '  boutique de Toronto',
  },
  shoppingCartSummaryComponent: {
    summary: 'Sommaire',
    agency: 'Agence',
    agencyFees: "Frais d'agence",
    saqFees: 'Frais SAQ',
    subTotal: 'Payé à la Saq',
    payNow: 'Payez maintenant',
    boutique: 'Boutique',
    tps: 'TPS',
    tvq: 'TVQ',
    total: 'Total',
    toPaySaq: 'À payer à la SAQ (+ tx.)',
    toPayNow: 'Sous-total',
    ctaOrder: 'Commander',
  },
  shoppingCartAuthModel: {
    placeOrder: 'Passer la commande',
    guestOrder: 'Commander comme invité',
    register: 'Déjà enregistré ?',
    registerNow: "S'enregistrer",
    signIn: 'Se connecter',
    continue: 'Continuer',
  }
};
